/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_AddressInputs */

const en_invoice_request_address = /** @type {(inputs: Invoice_Request_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const pl_invoice_request_address = /** @type {(inputs: Invoice_Request_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Invoice_Request_AddressInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_address = /** @type {((inputs?: Invoice_Request_AddressInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_AddressInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_address(inputs)
	return en_invoice_request_address(inputs)
});